<template>
  <div class="navigation-wrapper px-4">
    <nav class="nav-container">
      <div class="logo-container">
        <img
          src="/img/new_tf_logo.png"
          alt="TalentFind Logo"
          class="logo-image"
          @click="$router.push(TFW_LOGIN_URL())"
        />
      </div>

      <div class="nav-items-container">
        <ul
          class="nav-list"
          :class="$route.path.includes('/tfm/uae') ? 'd-none' : ''"
        >
          <li
            class="nav-item dropdown-parent"
            @mouseenter="showDropdown = 'career_pathway'"
            @mouseleave="showDropdown = ''"
            @click="
              showDropdown =
                showDropdown == 'career_pathway' ? '' : 'career_pathway'
            "
          >
            <span @click="navigateTo('/career-pathway')" class="nav-link">
              Careers
              <i class="dropdown-chevron fas fa-chevron-down"></i>
            </span>

            <transition name="dropdown-fade">
              <div
                v-if="showDropdown === 'career_pathway'"
                class="dropdown-panel"
              >
                <div class="dropdown-arrow"></div>
                <div class="dropdown-grid">
                  <div class="pathway-info">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Careers
                    </h3>
                    <p class="dropdown-description text-justify">
                      Whether you’re still studying, stepping into your first
                      role, hitting your career’s high notes, or even planning a
                      fulfilling retirement, our focus is on providing you with
                      the opportunities and resources for your career
                      development.
                    </p>
                    <div>
                    <!-- <div> -->
                      <button
                        class="btn btn-primary mr-3"
                        @click="$router.push('/tfm/register/#register-form')"
                      >
                        Start Your Journey
                      </button>
                    <!-- </div>
                    <div> -->
                      <button
                        class="btn btn-primary"
                        @click="
                          $router.push(
                            `/tfm/job-board/${getOrgDetail.customer_uid}`,
                          )
                        "
                      >
                        Explore Jobs
                      </button>
                    <!-- </div> -->
                  </div>
                  </div>

                  <div class="pathway-options">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Select Your Option
                    </h3>
                    <ul class="options-list">
                      <li
                        v-for="(menu, index) in career_pathway_menus"
                        :key="index"
                        class="option-link"
                        @click="
                          menu.path
                            ? navigateTo(menu.path, menu.section)
                            : handleScrollToSection(menu.section)
                        "
                      >
                        {{ menu.label }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </transition>
          </li>

          <li
            class="nav-item dropdown-parent"
            @mouseenter="showDropdown = 'professional_development'"
            @mouseleave="showDropdown = ''"
            @click="
              showDropdown =
                showDropdown == 'professional_development'
                  ? ''
                  : 'professional_development'
            "
          >
            <span
              @click="navigateTo('/professional-development')"
              class="nav-link"
            >
              Knowledge and News Hub
              <i class="dropdown-chevron fas fa-chevron-down"></i>
            </span>

            <transition name="dropdown-fade">
              <div
                v-if="showDropdown === 'professional_development'"
                class="dropdown-panel"
              >
                <div class="dropdown-arrow"></div>
                <div class="dropdown-grid">
                  <div class="pathway-info">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Knowledge and News Hub
                    </h3>
                    <p class="dropdown-description text-justify">
                      Whether you're looking to stay informed, explore expert
                      insights, or dive into the latest developments shaping the
                      health workforce, our Knowledge & News Hub is your gateway
                      to curated articles, news, and thought leadership. From
                      global trends to local innovations, we’re building a space
                      where knowledge fuels action - with more features coming
                      soon.
                    </p>
                  </div>

                  <div class="pathway-options">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Select your Option
                    </h3>
                    <ul class="options-list">
                      <li
                        v-for="(menu, index) in knowledge_news_hub_menus"
                        :key="index"
                        class="option-link"
                      >
                        <span
                          @click="
                            menu.path
                              ? navigateTo(menu.path)
                              : handleScrollToSection(menu.section)
                          "
                        >
                          {{ menu.label }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </transition>
          </li>

          <li
            class="nav-item dropdown-parent"
            @mouseenter="showDropdown = 'marketplace'"
            @mouseleave="showDropdown = ''"
            @click="
              showDropdown = showDropdown == 'marketplace' ? '' : 'marketplace'
            "
          >
            <span class="nav-link">
              Marketplace
              <i class="dropdown-chevron fas fa-chevron-down"></i>
            </span>

            <transition name="dropdown-fade">
              <div v-if="showDropdown === 'marketplace'" class="dropdown-panel-1">
                <div class="dropdown-arrow-1"></div>
                <div class="dropdown-grid-1">
                  <div class="pathway-info">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Marketplace
                    </h3>
                    <p class="dropdown-description text-justify">
                      Welcome to the TalentFind Marketplace – a growing
                      community of partners, providers, and innovators working
                      together to support the health workforce. Whether you're
                      seeking trusted services, training solutions, or strategic
                      collaborations, the Marketplace connects you with
                      opportunities to grow, share, and make impact. It’s also a
                      space to showcase your expertise and offerings to a global
                      audience — helping you build visibility, credibility, and
                      meaningful connections.
                    </p>
                  </div>

                  <div class="pathway-options">
                    <h3 class="dropdown-heading f-secondary font-25">
                      Select your Option
                    </h3>
                    <ul class="options-list">
                      <li
                        v-for="(menu, index) in marketplace"
                        :key="index"
                        class="option-link"
                        @click="menu.path ? navigateTo(menu.path) : null"
                      >
                        {{ menu.label }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </transition>
          </li>

          <!-- <li class="nav-item">
            <span @click="navigateTo('/news')" class="nav-link">News</span>
          </li> -->
          <!-- <li class="nav-item">
            <span @click="navigateTo('/uae')" class="nav-link">UAE</span>
          </li> -->
        </ul>
        <template>
          <button class="btn btn-primary m-0 text-none" @click="goToRegister()">
            Register/Login
          </button>
          <button
            class="btn btn-icon m-0"
            @click="$router.push(TFW_LOGIN_URL())"
          >
            <i class="fa-solid fa-house cursor-pointer"></i>
          </button>
        </template>
      </div>

      <!-- Mobile Navigation -->
      <div class="mobile-nav-toggle">
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="btn btn-primary me-3 mr-2 mt-0 bg-blue-500 text-white px-4 py-2 rounded1 register-button"
            @click="goToRegister()"
          >
            Register/Login
          </button>
          <button
            class="btn btn-icon me-3 mt-0 bg-blue-500 text-white px-4 py-2 rounded1 home-button"
            style="min-width: 50px !important"
            @click="$router.push(TFW_LOGIN_URL())"
          >
            <i class="fa-solid fa-house text-white cursor-pointer m-0 p-0"></i>
          </button>
          <!-- Login Icon -->
          <i
            class="d-none fa-solid fa-circle-user login-icon"
            @click="goToRegister()"
          ></i>
          <!-- Menu Icon -->
          <button class="btn btn-outline ml-2" @click="toggleSidebar">
            <i class="fa-solid fa-list"></i>
          </button>
        </div>
      </div>
    </nav>

    <!-- Sidebar -->
    <div class="mobile-nav-toggle">
      <div :class="['sidebar', { active: showSidebar }]">
        <button class="close-btn" @click="toggleSidebar">&times;</button>
        <ul class="list-unstyled mt-5">
          <li>
            <div class="d-flex justify-content-start align-items-center">
              <a
                href="#"
                class="text-white d-flex justify-content-between"
                style="color: white !important"
                @click="navigateTo('/career-pathway')"
              >
                Careers
              </a>
              <span @click="toggleSubMenu('career')">&#x276F;&#x276F;</span>
            </div>
            <ul v-if="activeSubMenu === 'career'" class="submenu">
              <li
                v-for="(menu, index) in career_pathway_menus"
                :key="index"
                @click="menu.path ? navigateTo(menu.path) : null"
              >
                {{ menu.label }}
              </li>
            </ul>
          </li>
          <li>
            <div class="d-flex justify-content-start align-items-center">
              <a
                href="#"
                class="text-white d-flex justify-content-between"
                style="color: white !important"
                @click="navigateTo('/professional-development')"
              >
                Knowledge & News Hub
              </a>
              <span @click="toggleSubMenu('development')"
                >&#x276F;&#x276F;</span
              >
            </div>
            <ul v-if="activeSubMenu === 'development'" class="submenu">
              <li
                v-for="(menu, index) in knowledge_news_hub_menus"
                :key="index"
                class="text-white"
                @click="
                  menu.path
                    ? navigateTo(menu.path)
                    : handleScrollToSection(menu.section)
                "
              >
                {{ menu.label }}
              </li>
            </ul>
          </li>
          <li>
            <div class="d-flex justify-content-start align-items-center">
              <a
                href="#"
                class="text-white d-flex justify-content-between"
                style="color: white !important"
              >
                Marketplace
              </a>
              <span @click="toggleSubMenu('marketplace')"
                >&#x276F;&#x276F;</span
              >
            </div>
            <ul v-if="activeSubMenu === 'marketplace'" class="submenu">
              <li
                v-for="(menu, index) in marketplace"
                :key="index"
                class="text-white"
                @click="menu.path ? navigateTo(menu.path) : null"
              >
                {{ menu.label }}
              </li>
            </ul>
          </li>
          <!-- <li @click="navigateTo('/news')" class="text-white ml-2 my-2">
            News
          </li> -->
          <!-- <li @click="navigateTo('/uae')" class="text-white ml-2 my-4">UAE</li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { routeToWebRegister, TFW_LOGIN_URL } from "../../helpers/helper";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      showDropdown: "",
      showSidebar: false,
      activeSubMenu: null,
      TFW_LOGIN_URL,
      career_pathway_menus: [
        { label: "Jobs", path: "/career-pathway/jobs" },
        { label: "Clinical Placements... coming soon", path: null },
        { label: "Professionals", path: "/career-pathway/professionals" },
        { label: "Students", path: "/career-pathway/students" },
        { label: "Language Courses", path: "/partner/directory/slc" },
        {
          label: "Professional Development",
          path: null,
          section: "professional-development",
        },
      ],
      knowledge_news_hub_menus: [
        { label: "News Articles", path: null, section: "news-articles" },
        { label: "More coming soon...", path: null },
        // { label: "Home", path: null, section: "new-articles" },
        // {
        //   label: "Contributor Dashboard",
        //   path: null,
        //   submenu: [
        //     { label: "Submit Article" },
        //     { label: "Access Speciality Communities" },
        //     { label: "Contributor Profile Management" },
        //   ],
        // },
        // { label: "Specialty Communities", path: null },
        // {
        //   label: "Career Development",
        //   path: null,
        //   submenu: [
        //     { label: "Mentorship" },
        //     { label: "Career Advice" },
        //     { label: "Job Market Insights" },
        //   ],
        // },
        // {
        //   label: "Specialty Training",
        //   path: null,
        //   submenu: [
        //     { label: "Courses" },
        //     { label: "Certifications" },
        //     { label: "Continuing Professional Development(CPD)" },
        //   ],
        // },
        // { label: "Global Medical Career Pathways", path: null },
        // {
        //   label: "Healthcare Transformation & Trends",
        //   path: null,
        //   submenu: [
        //     { label: "Primary Care Expansion" },
        //     { label: "Care in the Community" },
        //     { label: "Digital Health in Telemedicine" },
        //     { label: "Workforce Redesign" },
        //   ],
        // },
      ],
      marketplace: [
        { label: "Partner Directory", path: "/partner/directory" },
        { label: "More coming soon...", path: null },
      ],
    };
  },
  computed: {
    ...mapGetters(["getOrgDetail"]),
  },
  methods: {
    ...mapActions(["fetchOrgDetailsByAcronym"]),
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
      this.activeSubMenu = null;
    },
    toggleSubMenu(menu) {
      this.activeSubMenu = this.activeSubMenu === menu ? null : menu;
    },
    navigateTo(url, section = "") {
      let path = `/tfm${url}`;
      if (section) {
        path += `#${section}`;
      }
      if (this.$route.fullPath !== path) {
        this.$router.push(path);
      } else {
        this.$router.replace(path);
      }

      this.toggleSidebar();
    },
    goToRegister() {
      routeToWebRegister(this.$router);
    },
    handleScrollToSection(section) {
      if (section) {
        if (this.showSidebar) this.showSidebar = false;
        this.$emit("scrollToSection", section);
        this.$router.push({ path: "/tfm", hash: `#${section}` });
      }
    },
  },
  mounted() {
    this.fetchOrgDetailsByAcronym("tfm");
    this.$nextTick(() => {
      setTimeout(() => {
        const wrapper = document.querySelector(".c-wrapper");
        const main = document.querySelector(".c-wrapper .c-main");

        if (wrapper) {
          wrapper.style.setProperty("margin", "0px", "important");
        }
        if (main) {
          main.style.setProperty("padding", "0px", "important");
        }
      }, 200);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/stm.scss";

.mobile-nav-toggle {
  display: none;
}

.navigation-wrapper {
  font-family: $font-primary;
  font-size: 18px;
  padding: 17px;
  background: white;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}

.logo-image {
  height: 40px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
  @media (max-width: 1264px) {
    height: 30px;
  }
}

.nav-items-container {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-list {
  display: flex;
  gap: 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-item {
  position: relative;
  padding: 0.5rem 0;
}

.nav-link {
  color: #2a2a2a;
  font-weight: 600;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    color: #1a115a;
    text-decoration: underline;
  }
}

.dropdown-panel {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  max-width: 1000px;
  width: 100vw;
  background: $dark-primary;
  border-radius: 40px;
  padding: 2rem;
  margin-top: 1rem;
  z-index: 1000;
}

.dropdown-panel-1 {
  position: absolute;
  top: 100%;
  left: 10%;
  transform: translateX(-55%);
  max-width: 1000px;
  width: 100vw;
  background: $dark-primary;
  border-radius: 40px;
  padding: 2rem;
  margin-top: 1rem;
  z-index: 1000;
}

.dropdown-arrow-1 {
  position: absolute;
  top: -10px;
  left: 60%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid $dark-primary;
}

.dropdown-arrow {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 11px solid $dark-primary;
}

.dropdown-grid {
  display: grid;
  grid-template-columns: 1fr 0.75fr;
  gap: 2rem;
  color: white;
}

.dropdown-grid-1 {
  display: grid;
  grid-template-columns: 1fr 0.75fr;
  gap: 2rem;
  color: white;
}

.pathway-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.dropdown-heading {
  font-size: 1.25rem;
  margin: 0 0 1rem 0;
}

.dropdown-description {
  line-height: 1.6;
  opacity: 0.9;
}

.cta-button {
  align-self: flex-start;
  padding: 0.75rem 1.5rem;
  background: #ffffff;
  color: $dark-primary;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f0f0;
    transform: translateY(-2px);
  }
}

.options-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0;
  margin: 0;
}

.option-link {
  color: white;
  text-decoration: none;
  list-style: none;
  transition: opacity 0.2s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
}

.auth-button {
  background: $secondary;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: darken($secondary, 10%);
    transform: translateY(-2px);
  }
}

// .dropdown-fade-enter-active,
// .dropdown-fade-leave-active {
//   transition: opacity 0.2s ease, transform 0.2s ease;
// }

// .dropdown-fade-enter-from,
// .dropdown-fade-leave-to {
//   opacity: 0;
//   transform: translateX(-50%) translateY(-10px);
// }

@media (max-width: 1024px) {
  .nav-items-container {
    display: none;
  }

  .mobile-nav-toggle {
    display: block;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 80%;
    height: 100%;
    background: $dark-primary;
    color: white;
    padding: 20px;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 1000;
  }
  .sidebar.active {
    transform: translateX(0);
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 30px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
  }
  .submenu {
    padding-left: 20px;
    list-style: none;
  }
  .submenu li {
    margin-top: 5px;
  }

  a {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    text-decoration: none !important;
    padding: 10px !important;
  }
}

.login-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  font-size: 27px;
  border: 2px solid $btn-primary;
  border-radius: 15px;
  background-color: $btn-primary;
  cursor: pointer;
  color: white;
}
.btn-link-overide {
  color: $btn-primary;
  text-transform: unset !important;
}
.btn-link-overide:hover {
  color: $btn-primary;
}

.fs-6 {
  font-size: 1rem !important;
}
</style>
